import {
  ModalActionTypes,
  SHOW_DRAWER_SUCCESS,
  SHOW_DRAWER_ERROR,
  SHOW_DRAWER_STATEMENT,
  SHOW_DRAWER_MY_AGENT,
  SHOW_DRAWER_NOTIFICATION,
  SHOW_HELP_DRAWER,
  LOGOUT,
  SHOW_DRAWER_NOTIFICATION_DETAIL,
  SHOW_DRAWER_GRAINS,
  IDrawerInfo,
  SHOW_INVESTMENT_INFO
} from './types'

export interface State {
  showModal:
    | 'account'
    | 'options'
    | 'help'
    | 'howWorks'
    | 'selectorEnterprise'
    | 'filter'
    | 'signature'
    | 'logout'
    | null
  showDrawer: boolean
  drawerConfig: any
  selectedReceipt: string
  drawerInfo: Partial<IDrawerInfo>
  showDrawerSuccess: {
    show: boolean
    success: boolean
    title: string
    body: string
    navigation: {
      path: string
      title: string
      fromScreen: string
    }
    showBackArrow?: boolean
  }
  showDrawerError: {
    show: false
    title: string
    body: string
    navigation: {
      path: string
      title: string
      fromScreen: string
    }
    btnText?: string
    callback?: () => void
  }
  showStatementDrawer: boolean
  showDrawerNotificationDetail: boolean
  showAccountDrawer: boolean
  showDrawerMyAgent: boolean
  showDrawerOfTimeRange: boolean
  showDrawerNotification: boolean
  showDrawerContractDetail: boolean
  drawerGrains: {
    showDrawerGrains: boolean
    drawerConfig: {
      title: string
      config: string
    }
    drawerInfo: any
  }
  showHelpDrawer: {
    isOpen: boolean
    title: string
    text: string
  }
  showDrawerInvestmentInfo: boolean
}

const initialState: State = {
  showModal: null,
  showDrawer: false,
  drawerConfig: {
    title: '',
    config: ''
  },
  showStatementDrawer: false,
  showAccountDrawer: false,
  selectedReceipt: '',
  drawerInfo: {},
  showDrawerSuccess: {
    show: false,
    success: false,
    title: '',
    body: '',
    navigation: {
      path: '',
      title: '',
      fromScreen: ''
    },
    showBackArrow: false
  },
  showDrawerError: {
    show: false,
    title: '',
    body: '',
    navigation: {
      path: '',
      title: '',
      fromScreen: ''
    },
    btnText: '',
    callback: undefined
  },
  showDrawerMyAgent: false,
  showDrawerOfTimeRange: false,
  showDrawerNotification: false,
  showDrawerNotificationDetail: false,
  showDrawerContractDetail: false,
  drawerGrains: {
    showDrawerGrains: false,
    drawerConfig: {
      title: '',
      config: ''
    },
    drawerInfo: {}
  },
  showHelpDrawer: {
    isOpen: false,
    title: '',
    text: ''
  },
  showDrawerInvestmentInfo: false
}

// TODO: add typing for actions

export default function modalReducer(state = initialState, action: any): State {
  switch (action.type) {
    case ModalActionTypes.SHOW_MODAL:
      return {
        ...state,
        showModal: action.payload
      }
    case SHOW_DRAWER_STATEMENT: {
      const { showStatementDrawer } = action.payload
      return {
        ...state,
        showStatementDrawer
      }
    }
    case SHOW_DRAWER_SUCCESS: {
      const { show, success, title, body, navigation, showBackArrow } = action.payload
      return {
        ...state,
        showDrawerSuccess: {
          show,
          success,
          title,
          body,
          navigation,
          showBackArrow
        }
      }
    }
    case SHOW_DRAWER_ERROR: {
      return {
        ...state,
        showDrawerError: {
          ...action.payload,
          btnText: action.payload.btnText || 'Aceptar'
        }
      }
    }
    case SHOW_DRAWER_MY_AGENT: {
      return {
        ...state,
        showDrawerMyAgent: action.payload
      }
    }
    case SHOW_DRAWER_NOTIFICATION: {
      return {
        ...state,
        showDrawerNotification: action.payload
      }
    }
    case SHOW_DRAWER_NOTIFICATION_DETAIL: {
      return {
        ...state,
        showDrawerNotificationDetail: action.payload
      }
    }
    case SHOW_HELP_DRAWER: {
      return {
        ...state,
        showHelpDrawer: action.payload
      }
    }
    case SHOW_DRAWER_GRAINS: {
      const { showDrawerGrains, drawerConfig, drawerInfo } = action.payload
      return {
        ...state,
        drawerGrains: {
          showDrawerGrains: showDrawerGrains,
          drawerConfig,
          drawerInfo
        }
      }
    }
    case SHOW_INVESTMENT_INFO: {
      return {
        ...state,
        showDrawerInvestmentInfo: action.payload
      }
    }
    case LOGOUT:
      return {
        ...initialState
      }
    default:
      return state
  }
}
